import { useCallback } from 'react'
import { useLocalStorageState, loadLocalStorageState, setLocalStorageState } from '../hooks/useLocalStorage'

type Flag = 'newcampaigns' | 'v2' | 'calendar'

const makeKey = (flag: Flag) => `jro.ff.${flag}`

export const getFeatureFlag = (flag: Flag) => {
  const savedValue = loadLocalStorageState<'true' | 'false'>(makeKey(flag), 'false') === 'true'
  const params = new URLSearchParams(window.location.search)
  const setter = params.get(flag)
  const shouldEnable = setter === 'on'
  const shouldDisable = setter === 'off'
  if (shouldEnable && !savedValue) {
    setLocalStorageState(makeKey(flag), 'true')
    return true
  }
  if (shouldDisable && savedValue) {
    setLocalStorageState(makeKey(flag), 'false')
    return false
  }
  return savedValue
}

export const useFeatureFlag = (flag: Flag): [boolean, (newValue: boolean) => void] => {
  const [featureFlag, setFeatureFlag] = useLocalStorageState(makeKey(flag), 'false')
  const setFeatureFlagCallback = useCallback((newValue: boolean) => {
    const params = new URLSearchParams(window.location.search)
    if (params.has(flag)) {
      params.delete(flag)
      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`)
    }
    setFeatureFlag(newValue ? 'true' : 'false')

  }, [setFeatureFlag])

  return [featureFlag === 'true', setFeatureFlagCallback]
}

export const useFlagEnabled = (flag: Flag): boolean => {
  return useFeatureFlag(flag)[0]
}
